import { useContext } from 'react';
import { ScalprumContext } from './scalprum-context';
export function useScalprum(selector) {
    var state = useContext(ScalprumContext);
    if (typeof selector === 'function') {
        return selector(state);
    }
    return state;
}
//# sourceMappingURL=use-scalprum.js.map